import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function Notification({ notificationParams, setNotificationParams }) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  return (
    <ToastContainer
      position="top-end"
      className="p-3"
      style={{ position: "fixed", top: "20px", right: "20px", zIndex: 1050 }}
    >
      <Toast
        bg={notificationParams.bg}
        show={notificationParams.show}
        onClose={() =>
          setNotificationParams((prev) => ({ ...prev, show: false }))
        }
        delay={3000}
        autohide
      >
        <Toast.Header>
          <strong className="me-auto">{t("notification")}</strong>
          <small>{t("just_now")}</small>
        </Toast.Header>
        <Toast.Body>{notificationParams.message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default Notification;
